module.exports = __webpack_public_path__ + "static/media/line.68e319fd.svg";